<div class="row align-top gutters">
  <div class="col-md-4">
    <div
      [ngClass]="
        hasPricingPermissions
          ? 'subsection-header-with-button'
          : 'subsection-header'
      "
      class="gray"
      >
      @if (hasPricingPermissions) {
        <span></span>
      }
      Non-CRA Execution
      @if (hasPricingPermissions) {
        <span class="save-icon">
          <button mat-mini-fab (click)="toggleNonCRAEditMode()">
            @if (!isNonCRAEditMode) {
              <mat-icon>edit</mat-icon>
            }
            @if (isNonCRAEditMode) {
              <mat-icon>save</mat-icon>
            }
          </button>
        </span>
      }
    </div>
    <div class="row">
      <div class="col-md-12">
        @if (!isNonCRAEditMode || !hasPricingPermissions) {
          <div>
            @if (pricingDetails && pricingDetails.non_cra_execution !== '') {
              <div
                class="notes-read-only"
                >
                {{ pricingDetails.non_cra_execution }}
              </div>
            }
            @if (!pricingDetails || pricingDetails.non_cra_execution === '') {
              <i
                >There are no Non-CRA Execution notes for this deal.</i
                >
              }
            </div>
          }
          @if (isNonCRAEditMode && hasPricingPermissions) {
            <form>
              <mat-form-field>
                <mat-label>Type Non-CRA Execution notes here</mat-label>
                <textarea
                  matInput
                  [formControl]="nonCRA"
                  (change)="nonCRAChanged = true"
                ></textarea>
              </mat-form-field>
            </form>
          }
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div
      [ngClass]="
        hasPricingPermissions
          ? 'subsection-header-with-button'
          : 'subsection-header'
      "
        class="gray"
        >
        @if (hasPricingPermissions) {
          <span></span>
        }
        Pricing Details
        @if (hasPricingPermissions) {
          <span class="save-icon">
            <button mat-mini-fab (click)="toggleEditMode()">
              @if (!isEditMode) {
                <mat-icon>edit</mat-icon>
              }
              @if (isEditMode) {
                <mat-icon>save</mat-icon>
              }
            </button>
          </span>
        }
      </div>
      <div class="row pricing-row">
        <div class="col-md-6">
          <b class="pricing-label">Placement Guidance Expiration Date: </b>
        </div>
        @if (!isEditMode || !hasPricingPermissions) {
          <div class="col-md-6">
            @if (placementExpDateNewFormatted !== '') {
              <span>{{
                placementExpDateNewFormatted
              }}</span>
            }
            @if (placementExpDateNewFormatted === '') {
              <span>N/A</span>
            }
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-5">
            <mat-form-field appearance="fill">
              <mat-label>Enter a date</mat-label>
              <input
                matInput
                [matDatepicker]="datepicker"
                [value]="placementExpDateNew"
                (dateChange)="changeDate($event, 'placementExp')"
                />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker> </mat-datepicker>
            </mat-form-field>
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-1">
            <button
              mat-icon-button
              color="warn"
              aria-label="Delete Date"
              (click)="deleteDate('placementExp')"
              >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        }
      </div>

      <div class="row pricing-row">
        <div class="col-md-6">
          <b class="pricing-label">Placement Guidance Issued Date: </b>
        </div>
        @if (!isEditMode || !hasPricingPermissions) {
          <div class="col-md-6">
            @if (placementIssuedDateNewFormatted !== '') {
              <span>{{
                placementIssuedDateNewFormatted
              }}</span>
            }
            @if (placementIssuedDateNewFormatted === '') {
              <span>N/A</span>
            }
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-5">
            <mat-form-field appearance="fill">
              <mat-label>Enter a date</mat-label>
              <input
                matInput
                [matDatepicker]="datepicker"
                [value]="placementIssuedDateNew"
                (dateChange)="changeDate($event, 'placementIssued')"
                />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker> </mat-datepicker>
            </mat-form-field>
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-1">
            <button
              mat-icon-button
              color="warn"
              aria-label="Delete Date"
              (click)="deleteDate('placementIssued')"
              >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        }
      </div>

      <div class="row pricing-row">
        <div class="col-md-6">
          <b class="pricing-label">Response to Developer Needed: </b>
        </div>
        @if (!isEditMode || !hasPricingPermissions) {
          <div class="col-md-6">
            @if (responseDateNewFormatted !== '') {
              <span>{{
                responseDateNewFormatted
              }}</span>
            }
            @if (responseDateNewFormatted === '') {
              <span>N/A</span>
            }
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-5">
            <mat-form-field appearance="fill">
              <mat-label>Enter a date</mat-label>
              <input
                matInput
                [matDatepicker]="datepicker"
                [value]="responseDateNew"
                (dateChange)="changeDate($event, 'responseDate')"
                />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker> </mat-datepicker>
            </mat-form-field>
          </div>
        }
        @if (isEditMode && hasPricingPermissions) {
          <div class="col-md-1">
            <button
              mat-icon-button
              color="warn"
              aria-label="Delete Date"
              (click)="deleteDate('responseDate')"
              >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
